module.exports = __webpack_public_path__ + "static/media/infoJumbo2.3de3725c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/nordlock/images/infoJumbo2.jpg
// module id = 550
// module chunks = 0